import { Path, Svg } from '@react-pdf/renderer';

export const LocationIcon = ({ color }: { color: string }) => {
  return (
    <Svg width="16px" height="16px" viewBox="0 0 24 24" style={{marginTop: '4px', marginBottom: '4px'}}>
      <Path
        fill={color}
        d="M12 2C8.13 2 5 5.13 5 9c0 4.17 4.42 9.92 6.24 12.11a1 1 0 0 0 1.52 0C14.58 18.92 19 13.17 19 9c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 14.5 9 2.5 2.5 0 0 1 12 11.5z"
      />
    </Svg>
  );
};
